/* eslint-disable linebreak-style */
export const StyledTypoName = {
  display: 'block',
  fontSize: '12px',
  padding: '2px',
  margin: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',

  '@media (min-width: 550px)': {
    fontSize: '14px'
  },

  '@media (min-width: 750px)': {
    fontSize: '16px'
  }
};

export const StyledTypoRate = {
  fontSize: '12px',
  padding: '2px',

  '@media (min-width: 550px)': {
    fontSize: '14px'
  },

  '@media (min-width: 750px)': {
    fontSize: '16px'
  }
};